import { useState } from 'react'

/**
 * O carimbo de quando a busca terminou (demanda 109).
 *
 * ⚠️ Marca no **fim** da busca, não no começo: o que interessa a quem lê é a
 * idade do dado exibido, e ele só existe quando a resposta chega.
 *
 * Fica em arquivo próprio porque `BarraDeAtualizacao.tsx` exporta um componente
 * — misturar os dois quebra o *fast refresh* do Vite.
 */
export function useFrescor() {
  const [em, setEm] = useState<Date | null>(null)
  return { em, marcar: () => setEm(new Date()) }
}
